import { graphql } from "react-relay";

export const AddBindingMutation = graphql`
  mutation AddBindingMutation($connections: [ID!]!, $input: AddBindingInput!) {
    addBinding(input: $input) {
      binding
        @appendNode(connections: $connections, edgeTypeName: "BindingEdge") {
        accountGroup {
          name
          provider
          uuid
        }
        autoDeploy
        description
        executionConfig {
          dryRun {
            default
          }
          variables
        }
        id
        lastDeployed
        name
        policyCollection {
          name
          provider
          uuid
        }
        schedule
        uuid
      }
    }
  }
`;
